import React, { useState } from "react";
import "./App.css";

import Intro from "./components/intro";
import Test from "./components/test";
import "./style/style.css";

function App() {
  const [firstpage, setFirstpage] = useState(true);

  const startQ = () => {
    setFirstpage(!firstpage);
  };

  return (
    <div className="App">
      <h1 className={"main-header"}>SPIRITUAL GIFTS SURVEY</h1>
      {firstpage && <Intro toggleStart={startQ} />}
      {!firstpage && <Test />}
    </div>
  );
}

export default App;
